/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .button-bar {
    display: flex;
    flex-direction: row;

    .button-group {
      display: flex;
      flex-direction: row;
      gap: 0.2em;

      & + .button-group {
        margin-left: 1em;
      }
    }
  }
`;
